<div class="w-full max-w-6xl p-4 sm:p-8">
    <div class="prose prose-sm !max-w-100 col-span-4 mb-5">
        <h2>{{ 'label_translations' | translate }}</h2>
    </div>
    <span class="separator-line block mb-[px]"></span>
    <div id="header" class="flex flex-col sm:flex-row md:flex-col flex-auto justify-between py-4 pr-6 border-b">
        <!-- Main actions -->
        <div class="flex items-center">
            <!-- Search -->
            <div class="flex-auto">
                <mat-form-field class="fuse-mat-dense fuse-mat-no-subscript fuse-mat-rounded w-full min-w-50">
                    <mat-icon class="icon-size-5" matPrefix [svgIcon]="'heroicons_solid:search'"></mat-icon>
                    <input matInput [placeholder]="'label_search' | translate" (keyup)="searchFilter($event.target.value)" />
                </mat-form-field>
            </div>
            <!-- Add contact button -->
            @if (lsrauthService.inRole(userDetails, userRoles.TRANSLATIONS_SUPERUSER_ROLE)) {
                <button class="ml-4" mat-flat-button [color]="'primary'" (click)="addSettings()">
                    <mat-icon [svgIcon]="'heroicons_outline:plus'"></mat-icon>
                    <span class="ml-2 mr-1 hidden md:block">{{ 'label_register' | translate }}</span>
                </button>
            }
        </div>
    </div>
    <form [formGroup]="form" class="flex-auto space-between">
        <table matSort mat-table [dataSource]="dataSource">
            <!-- area -->
            <ng-container matColumnDef="context">
                <th clsass="pr-10" style="width: 300px" mat-sort-header="context" mat-header-cell *matHeaderCellDef>
                    {{ 'label_area' | translate }}
                </th>
                <td class="pr-10" style="width: 300px" mat-cell *matCellDef="let group" [formGroup]="group">
                    {{ group.get('context').value }}
                </td>
            </ng-container>
            <!-- translationkey -->
            <ng-container matColumnDef="translationKey">
                <th style="width: 600px" mat-sort-header="translationKey" mat-header-cell *matHeaderCellDef>
                    {{ 'label_name' | translate }}
                </th>
                <td style="width: 600px" mat-cell *matCellDef="let group" [formGroup]="group">
                    {{ group.get('translationKey').value }}
                </td>
            </ng-container>
            <!-- translationvalue -->
            <ng-container matColumnDef="translationValue">
                <th class="pl-6" style="width: 1200px" mat-sort-header=" translationValue" mat-header-cell *matHeaderCellDef>
                    {{ 'label_value' | translate }}
                </th>
                <td class="pl-6" style="width: 1200px" mat-cell *matCellDef="let group" [formGroup]="group">
                    <div class="mt-2 mb-2">
                        <!-- zero -->
                        <div class="container">
                            @if (group.get('zero').value) {
                                <mat-form-field class="mb-2 w-full">
                                    <input type=" text" matInput formControlName="zero" />
                                    @if (checkHasChangesZero(group.get('translationId').value)) {
                                        <mat-icon
                                            class="icon-size-5"
                                            svgIcon="mat_solid:edit"
                                            [matTooltip]="getInitialValue(group.get('translationId').value, 'zero')"
                                        ></mat-icon>
                                    }
                                </mat-form-field>
                            }
                        </div>
                        <!-- one -->
                        @if (group.get('one').value) {
                            <mat-form-field class="mb-2 w-full">
                                <input type=" text" matInput formControlName="one" />
                                @if (checkHasChangesOne(group.get('translationId').value)) {
                                    <mat-icon
                                        class="icon-size-5"
                                        svgIcon="mat_solid:edit"
                                        [matTooltip]="getInitialValue(group.get('translationId').value, 'one')"
                                    ></mat-icon>
                                }
                            </mat-form-field>
                        }
                        <!-- other: plural -->
                        @if (group.get('other').value) {
                            <mat-form-field class="w-full">
                                <input type="text" matInput formControlName="other" />
                                @if (checkHasChangesOther(group.get('translationId').value)) {
                                    <mat-icon
                                        class="icon-size-5"
                                        svgIcon="mat_solid:edit"
                                        [matTooltip]="getInitialValue(group.get('translationId').value, 'other')"
                                    ></mat-icon>
                                }
                            </mat-form-field>
                        }
                    </div>
                    <!-- values not starting with count -->
                    @if (!group.get('one').value) {
                        <mat-form-field class="mb-2 w-full">
                            <input type=" text" matInput formControlName="translationValue" />
                            @if (checkHasChanges(group.get('translationId').value)) {
                                <mat-icon
                                    class="icon-size-5"
                                    svgIcon="mat_solid:edit"
                                    [matTooltip]="getInitialValue(group.get('translationId').value, 'value')"
                                ></mat-icon>
                            }
                        </mat-form-field>
                    }
                </td>
            </ng-container>
            <ng-container matColumnDef="action" class="w-5">
                <th style="width: 150px" mat-sort-header="action" mat-header-cell *matHeaderCellDef></th>
                <td style="width: 150px" mat-cell *matCellDef="let group">
                    <span>
                        <!-- Delete translations settings -->
                        @if (lsrauthService.inRole(userDetails, userRoles.TRANSLATIONS_SUPERUSER_ROLE)) {
                            <button
                                mat-icon-button
                                (click)="deleteTranslation(group.get('translationId').value)"
                                [matTooltip]="'Eyða þýðingum'"
                            >
                                <mat-icon class="icon-size-5 text-current" [svgIcon]="'heroicons_solid:trash'"></mat-icon>
                            </button>
                        }
                    </span>
                </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: tableColumns"></tr>
        </table>
        <mat-paginator #tablePaginator class="justify-end" showFirstLastButtons [pageSize]="10" [pageSizeOptions]="[5, 10, 25, 50]">
        </mat-paginator>
        <!-- buttons -->
        <div class="flex items-center justify-end mt-4">
            <button
                mat-stroked-button
                type="button"
                [disabled]="
                    (pendingChanges.length == 0 &&
                        pendingChangesZero.length == 0 &&
                        pendingChangesOne.length == 0 &&
                        pendingChangesOther.length == 0) ||
                    form.pristine
                "
                (click)="resetValues()"
            >
                {{ 'label_clear_changes' | translate }}
            </button>
            <button
                class="ml-4"
                mat-flat-button
                type="submit"
                [disabled]="
                    (pendingChanges.length == 0 &&
                        pendingChangesZero.length == 0 &&
                        pendingChangesOne.length == 0 &&
                        pendingChangesOther.length == 0) ||
                    !form.valid
                "
                (click)="save()"
                [color]="'primary'"
            >
                {{ 'label_save' | translate }}
            </button>
        </div>
    </form>
</div>
